import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import AIAnswerBlock from "./components/AIAnswerBlock";
import Process from "./components/Process";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreas from "./components/ServiceAreas";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="w-full overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <AIAnswerBlock />
      <Process />
      <WhyChooseUs />
      <ServiceAreas />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
